import { Document, Page, View, StyleSheet } from '@react-pdf/renderer';
import { AdSummary, UserModel } from '@/types';
import { PortableView } from './PortableView';
import { ContactSection } from './PortableView/ContactSection';

type SelectedDataType = {
  isAgencyInformationVisible?: boolean;
  isBrokersInformationVisible?: boolean;
  showPrice?: boolean;
};

interface IPdfDocument {
  showContent: SelectedDataType;
  adsData: AdSummary[];
  personalInfo: UserModel;
}

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Poppins',
    fontSize: 40,

    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
});

export function GeneratePDF({ showContent, adsData, personalInfo }: IPdfDocument) {
  const A4_WIDTH = 300;
  return (
    <Document>
      {adsData.map((ad) => (
        <PortableView
          key={ad.id}
          adsData={ad}
          personalInfo={personalInfo}
          showContent={showContent}
        />
      ))}
      <Page size={[A4_WIDTH]} dpi={300} style={styles.page}>
        <View>
          <ContactSection
            showBroker={showContent.isBrokersInformationVisible}
            showAgency={showContent.isAgencyInformationVisible}
            contactInfo={personalInfo}
          />
        </View>
      </Page>
    </Document>
  );
}
